module.exports = "https://redage.akamaized.net/src/views/player/documets/army/images/Armylogo.png";